function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { useEffect as d, useRef as f } from "react";
import { FocusableMode as p, isFocusableElement as C } from '../utils/focus-management.js';
import { isMobile as M } from '../utils/platform.js';
import { useDocumentEvent as l } from './use-document-event.js';
import { useWindowEvent as T } from './use-window-event.js';
function y(s, m) {
  var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
  var i = f(!1);
  d(function () {
    requestAnimationFrame(function () {
      i.current = a;
    });
  }, [a]);
  function c(e, r) {
    if (!i.current || e.defaultPrevented) return;
    var t = r(e);
    if (t === null || !t.getRootNode().contains(t) || !t.isConnected) return;
    var E = function u(n) {
      return typeof n == "function" ? u(n()) : Array.isArray(n) || n instanceof Set ? n : [n];
    }(s);
    var _iterator = _createForOfIteratorHelper(E),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var u = _step.value;
        if (u === null) continue;
        var n = u instanceof HTMLElement ? u : u.current;
        if (n != null && n.contains(t) || e.composed && e.composedPath().includes(n)) return;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return !C(t, p.Loose) && t.tabIndex !== -1 && e.preventDefault(), m(e, t);
  }
  var o = f(null);
  l("pointerdown", function (e) {
    var r, t;
    i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
  }, !0), l("mousedown", function (e) {
    var r, t;
    i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
  }, !0), l("click", function (e) {
    M() || o.current && (c(e, function () {
      return o.current;
    }), o.current = null);
  }, !0), l("touchend", function (e) {
    return c(e, function () {
      return e.target instanceof HTMLElement ? e.target : null;
    });
  }, !0), T("blur", function (e) {
    return c(e, function () {
      return window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null;
    });
  }, !0);
}
export { y as useOutsideClick };